import React from 'react';
import './DataPower.css';

// Import the new monitor image
import monitorImage from '../../assets/images/platform-monitor.png';
// Import a checkmark icon from our icon library
import { BsCheckCircleFill } from 'react-icons/bs';

const DataPower = () => {
  return (
    <section className="data-power-section">
      <div className="data-power-container">
        {/* --- Left Column: Image --- */}
        <div className="data-power-image-col">
          <img src={monitorImage} alt="CRISHI platform on a monitor" />
          <p className="image-caption">
            Watch our quick video to see how easy it is to navigate the CRISHI website and make the most of our powerful platform.
          </p>
        </div>

        {/* --- Right Column: Text Content --- */}
        <div className="data-power-text-col">
          <h2>Unlocking the power of data: discover how CRISHI empowers your business</h2>
          <p className="description">
            The crop market is complex, but with the right data and insights, you can make confident, informed decisions. CRISHI offers comprehensive data, pricing, and market intelligence solutions to help you:
          </p>
          <ul className="features-list">
            <li><BsCheckCircleFill className="check-icon" /> Benchmark prices</li>
            <li><BsCheckCircleFill className="check-icon" /> Understand market shifts</li>
            <li><BsCheckCircleFill className="check-icon" /> Predict future outlook</li>
            <li><BsCheckCircleFill className="check-icon" /> Stay connected with the industry</li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default DataPower;